Number.prototype.round = function (fractionDigits){
  fractionDigits = fractionDigits || 2;
  var num = this;
  return Number.isInteger(num) ? num : Number(num.toFixed(fractionDigits))
}